import { z } from "zod";

export const DailyReportFilterSchemaV4 = z.object({
    property_id: z.string(), // Memastikan property_id adalah rentetan
    base_on: z.enum(["stay_date", "created_reservation"]), // Wajib untuk v4
    start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // Menguatkuasakan format YYYY-MM-DD
    end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // Menguatkuasakan format YYYY-MM-DD
});

export type DailyReportFilterV4Type = z.infer<typeof DailyReportFilterSchemaV4>;